export const ldapConfigForm = {
    button: {
        save: 'Save',
    },
    title: {
        serverUrl: 'Ldap server url',
        baseUsersDn: 'Base users distinguished name',
        adminDn: 'Admin distinguished name',
        adminPassword: 'Admin password',
        country: 'Country',
    },
    placeholder: {
        serverUrl: 'Enter LDAP server url',
        baseUsersDn: 'Enter base users',
        adminDn: 'Enter admin distinguished name',
        adminPassword: 'Enter admin password',
        country: 'Select country',
    },
    ldapUserList: {
        email: 'Email',
        username: 'Username',
    },
};
